import { GetterTree } from 'vuex';
import { EnrollmentState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<EnrollmentState, RootState> = {
  enrollmentId: (state, getters) => {
    return state.enrollmentId;
  },

  areDocumentsSent: (state, getters) => {
    return state.areDocumentsSent;
  },

  enrollmentStatus: (state, getters) => {
    return state.enrollmentStatus;
  },

  partnerCode: (state, getters) => {
    return state.partnerCode;
  },

  course: (state, getters) => {
    return state.course;
  },

  courseName: (state, getters) => {
    return state.course?.name;
  },

  campus: state => {
    return state.campus;
  },

  hasErrorVoucher: (state, getters) => {
    return state.hasErrorVoucher;
  },

  isComplementaryModuleEnabled: (state, getters) => {
    return state.isComplementaryModuleEnabled;
  },

  backofficeStudentAcademicRecord: (state, getters) => {
    return state.backofficeStudentAcademicRecord;
  },
};
export default getters;
